import { denyAccessRequest } from '@infuse/api/iam/access-request';
import { UiNotificationType } from '@infuse/ui/domain';
import { useNotify } from '@infuse/ui/services';
import { getAxiosErrorMessage } from '@infuse/utils';
import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { useI18n } from 'vue-i18n';

export const useDenyAccessRequest = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { t } = useI18n({ useScope: 'global' });

  const mutation = useMutation({
    mutationFn: async (id: string) => {
      try {
        const result = await denyAccessRequest({ id }, undefined);
        notify({
          title: t('iam.access-requests.header.access-requests'),
          message: t('iam.access-requests.notify.denied')
        });
        return result;
      } catch (e) {
        notify({
          type: UiNotificationType.ERROR,
          title: t('iam.access-requests.header.access-requests'),
          message: getAxiosErrorMessage(e, t('iam.access-requests.notify.deny_failed'))
        });
        throw e;
      }
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: ['access-requests'] });
    }
  });

  return { ...mutation };
};
